import { buildURL } from "react-imgix";
import LazyLoad from "react-lazyload";

import { Image } from "@/storybook-components";

const imgixSource =
  process.env.IMGIX_SOURCE || process.env.NEXT_PUBLIC_IMGIX_SOURCE;
const assetPrefix =
  process.env.ASSET_PREFIX || process.env.NEXT_PUBLIC_ASSET_PREFIX;

export interface Imigx {
  src: string;
  htmlAttributes: { [key: string]: string };
  imgixParams?: { [key: string]: string | number };
  imageLazyLoad?: boolean | string;
  addAssetPrefix?: boolean;
}

const BazaarImage = ({
  src,
  imgixParams,
  imageLazyLoad,
  htmlAttributes,
  addAssetPrefix
}: Imigx): JSX.Element => {
  const fallbackImage =
    "data:image/gif;base64,R0lGODlhAQABAAAAACH5BAEKAAEALAAAAAABAAEAAAICTAEAOw==";

  if (!src || !imgixSource)
    return <Image {...htmlAttributes} src={fallbackImage} />;

  const renderImgixImage = (src: string) => {
    let url = src.replace(/(s3-|s3\.)?(.*)\.amazonaws\.com(\/(.*?)\/)/, "");
    url = `https://${imgixSource}/${url}`;

    // Todo: remove react-imgix and replace it with imgix/js-core
    return (
      <Image {...htmlAttributes} src={decodeURI(buildURL(url, imgixParams))} />
    );
  };

  if (imageLazyLoad) {
    return (
      <LazyLoad once offset={100} height={250}>
        {addAssetPrefix ? (
          <Image {...htmlAttributes} src={`${assetPrefix}/${src}`} />
        ) : (
          renderImgixImage(src)
        )}
      </LazyLoad>
    );
  }

  return renderImgixImage(src);
};

export default BazaarImage;
